<script>
export default {
    name: 'IlluYes',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-yes"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <rect
                :stroke="secondaryColor"
                class="secondary-color"
                x="9.5"
                y="28.5"
                width="11"
                height="23"
                rx="3"
            />
            <circle
                :fill="primaryColor"
                class="primary-color"
                cx="15"
                cy="45"
                r="3"
            />
            <path
                d="M30.262 13.13c-1.048 4.07-2.624 7.462-4.72 10.176-2.015 2.61-3.694 5.87-5.042 9.778v14.692c4.235 3.773 7.49 5.724 9.794 5.724h20.033c.885-.148 1.56-.424 2.008-.859.423-.41.62-.961.62-1.641 0-.732-.143-1.358-.445-1.871-.295-.503-.742-.893-1.331-1.18l-1.422-.69 1.56-.253c.904-.146 1.593-.423 2.048-.865.422-.41.62-.961.62-1.641a2.37 2.37 0 00-.749-1.766c-.552-.537-1.386-.946-2.487-1.252l-2.43-.674 2.503-.304c1.25-.152 2.198-.477 2.825-1.01.576-.49.853-1.158.853-1.994 0-.837-.278-1.509-.855-2.004-.628-.539-1.576-.872-2.827-1.035l.069-.995c1.234.01 2.17-.183 2.791-.63.562-.405.822-1.025.822-1.836 0-.83-.317-1.49-.96-1.976-.712-.538-1.783-.869-3.2-1.024H33.77c1.462-5.744 2.241-10.159 2.33-13.246.04-1.43-.065-2.564-.331-3.401-.223-.702-.55-1.185-1.039-1.393-1.007-.43-1.882-.436-2.61.06-.786.534-1.388 1.586-1.858 3.11z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
        </g>
    </svg>
</template>
